import { Box, OutlinedInput, InputAdornment, IconButton} from '@mui/material';
import { ClearIcon } from '@mui/x-date-pickers';
import { useTheme } from "@mui/material/styles";
import {useContext, useRef, useState, useEffect } from "react";
import SearchIcon from '../../assets/common/search.svg';
import { GlobalContext } from '../../context/GlobalContext';

const KeywordSearch = () => {
    const theme = useTheme();
    const [searchText, setSearchText] = useState("");
    const { reportingSearch, setReportingSearch } = useContext(GlobalContext);
    const inputRef = useRef<HTMLDivElement>(null); 

    useEffect(() => {
    setSearchText(reportingSearch || "");
  }, [reportingSearch]);

  return (
    <Box className=" flex-start " sx={{ position: 'relative', ml: 3.7 }} ref={inputRef}>
      <OutlinedInput
        placeholder="keyword"
        value={searchText}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const value = event.target.value;
          setSearchText(value);
          if (value.trim() === "") {
            setReportingSearch("");
          }          
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            setReportingSearch(searchText.trim());
          }
        }}
        startAdornment={
          <InputAdornment position="start">
            <img src={SearchIcon} style={{ height: "24px", width: "24px" }} />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment  position="end">
            {searchText && (
              <IconButton onClick={() => {setSearchText(''); setReportingSearch("");}} sx={{ cursor: "pointer" }}>
                <ClearIcon />
              </IconButton>
            )}
          </InputAdornment>
        }
        sx={{
          flex: 0.9,
          width:"360px",
          height: "40px",
          borderRadius: "0px",
          right: "1px",
          border: "none",
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "1px solid #E5E5E5",
            borderRadius: "8px",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E5E5E5",
          },
          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: theme.palette.tertiary.main,
          },
          "& input::placeholder": {
            fontFamily: 'var(--font-family)',
            fontWeight: 400,
            fontSize: "17px",
            lineHeight: "24px",
            letterSpacing: "-0.16px",
            color: theme.palette.primary.dark,
            [theme.breakpoints.down("lg")]: {
              fontSize: "15px",
            },
          },
        }}
      />
    </Box>
  );
};

export default KeywordSearch;
